import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

const GAPCategoryFilter = ({ facets, filters, setFilter, removeFilter }) => {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="category"
      filters={filters}
      id="heritage-category"
      label="Heritage category"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
};

export default withSearch(({ facets, filters, setFilter, removeFilter }) => ({
  facets,
  filters,
  setFilter,
  removeFilter,
}))(GAPCategoryFilter);
